import { ensureAll } from '../store/busesSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';



function BusSelect({ innerRef, ...props }) {

    const dispatch = useDispatch();
    const _buses = useSelector((state) => state.buses.knownBuses);
    const buses = Object.values(_buses).sort((a, b) => a.bus_name.localeCompare(b.bus_name));

    useEffect(() => {
        dispatch(ensureAll());
    }, []);

    return (
        <select ref={innerRef} {...props} >
            { buses.map(bus => (!bus.bus_hidden) && (
                <option value={bus.bus_id}>{bus.bus_name}</option>
            )) }
        </select>
    );
};

export default BusSelect;